'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgAdd, SvgBenefitFill, SvgMyFill, SvgShoppingBasketFill, SvgStore } from '@common/icon';
import { cn } from '@core/utils';
import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { CustomLink } from '@/app/_components/CustomLink';
import { ServiceSwitchDropdown } from '@/app/_components/ServiceSwitchDropdown';
import { ROUTES, WEL_MARKET_ROUTES } from '@/constants';
import { useHaptic } from '@/hooks/useHaptic';
import { useAdpopcornStatus } from '@/modules/adpopcorn';
const ANIMATION_DURATION = 300;
type LocalMarketBnbLinkItem = {
  kind: 'link';
  label: string;
  route: {
    pathname: string;
  };
  icon: typeof SvgStore;
};
type LocalMarketBnbItem = LocalMarketBnbLinkItem;
const LOCAL_MARKET_BNB_ITEMS: readonly LocalMarketBnbItem[] = [{
  kind: 'link',
  label: '홈',
  route: WEL_MARKET_ROUTES.HOME,
  icon: SvgStore
}, {
  kind: 'link',
  label: '장바구니',
  route: WEL_MARKET_ROUTES.CART,
  icon: SvgShoppingBasketFill
}, {
  kind: 'link',
  label: '혜택',
  route: ROUTES.BENEFIT,
  icon: SvgBenefitFill
}, {
  kind: 'link',
  label: '마이페이지',
  route: ROUTES.MY,
  icon: SvgMyFill
}];
export const LocalMarketBnb = () => {
  const $ = _c(40);
  const pathname = usePathname();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [menuClickAnimated, setMenuClickAnimated] = useState(t0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const {
    isExternalWebview
  } = useAdpopcornStatus();
  const {
    triggerHaptic
  } = useHaptic();
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[1] !== isDropdownOpen || $[2] !== isExternalWebview || $[3] !== menuClickAnimated || $[4] !== pathname || $[5] !== triggerHaptic) {
    let t6;
    if ($[11] !== isExternalWebview) {
      t6 = item => item.route.pathname !== ROUTES.BENEFIT.pathname || !isExternalWebview;
      $[11] = isExternalWebview;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    const visibleItems = LOCAL_MARKET_BNB_ITEMS.filter(t6);
    let t7;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = index => {
        setMenuClickAnimated(prev => ({
          ...prev,
          [index]: true
        }));
        setTimeout(() => {
          setMenuClickAnimated(prev_0 => ({
            ...prev_0,
            [index]: false
          }));
        }, ANIMATION_DURATION);
      };
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    const handleMenuClick = t7;
    t3 = "\uC6F0\uB9C8\uCF19 \uB0B4\uBE44\uAC8C\uC774\uC158";
    t4 = "relative flex size-full items-center p-8";
    let t8;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = () => setIsDropdownOpen(_temp);
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    let t9;
    if ($[15] !== isDropdownOpen) {
      t9 = cn("size-20 text-Gray-600 transition-transform duration-200", {
        "rotate-45": isDropdownOpen
      });
      $[15] = isDropdownOpen;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    let t10;
    if ($[17] !== t9) {
      t10 = <SvgAdd className={t9} />;
      $[17] = t9;
      $[18] = t10;
    } else {
      t10 = $[18];
    }
    let t11;
    if ($[19] !== isDropdownOpen || $[20] !== t10) {
      t11 = <button type="button" className="relative z-50 size-40 rounded-pill bg-Gray-200 flex-center" onClick={t8} aria-label={"\uB2E4\uB978 \uC11C\uBE44\uC2A4\uB85C \uC774\uB3D9"} aria-expanded={isDropdownOpen}>{t10}</button>;
      $[19] = isDropdownOpen;
      $[20] = t10;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = () => setIsDropdownOpen(false);
      $[22] = t12;
    } else {
      t12 = $[22];
    }
    let t13;
    if ($[23] !== isDropdownOpen) {
      t13 = <ServiceSwitchDropdown isOpen={isDropdownOpen} onClose={t12} currentService="market" />;
      $[23] = isDropdownOpen;
      $[24] = t13;
    } else {
      t13 = $[24];
    }
    if ($[25] !== t11 || $[26] !== t13) {
      t5 = <div className="relative z-50">{t11}{t13}</div>;
      $[25] = t11;
      $[26] = t13;
      $[27] = t5;
    } else {
      t5 = $[27];
    }
    t1 = "flex flex-1 items-center justify-around px-12";
    let t14;
    if ($[28] !== menuClickAnimated || $[29] !== pathname || $[30] !== triggerHaptic) {
      t14 = (item_0, index_0) => {
        const itemAnimationStyle = {
          animationDuration: `${ANIMATION_DURATION}ms`
        } as const;
        const Icon = item_0.icon;
        const isActive = (() => {
          if (!pathname) {
            return false;
          }
          if (item_0.route.pathname === WEL_MARKET_ROUTES.HOME.pathname) {
            return pathname === item_0.route.pathname;
          }
          return pathname.includes(item_0.route.pathname);
        })();
        const isCurrentPage = pathname === item_0.route.pathname;
        return <li key={item_0.label} className="w-53"><CustomLink href={item_0.route.pathname} aria-label={`${item_0.label} 페이지로 이동`} prefetch={true} className={cn("flex w-full flex-col items-center", menuClickAnimated[index_0] && "animate-jump")} style={itemAnimationStyle} onClick={() => {
            if (!isCurrentPage) {
              triggerHaptic();
            }
            handleMenuClick(index_0);
          }}><Icon className={cn("size-28 text-Gray-400", {
              "text-Gray-black": isActive
            })} /><p className={cn("whitespace-nowrap text-center font-500 text-Gray-550 typo-caption2", {
              "font-600 text-Gray-900": isActive
            })}>{item_0.label}</p></CustomLink></li>;
      };
      $[28] = menuClickAnimated;
      $[29] = pathname;
      $[30] = triggerHaptic;
      $[31] = t14;
    } else {
      t14 = $[31];
    }
    t2 = visibleItems.map(t14);
    $[1] = isDropdownOpen;
    $[2] = isExternalWebview;
    $[3] = menuClickAnimated;
    $[4] = pathname;
    $[5] = triggerHaptic;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
  }
  let t6;
  if ($[32] !== t1 || $[33] !== t2) {
    t6 = <ul className={t1}>{t2}</ul>;
    $[32] = t1;
    $[33] = t2;
    $[34] = t6;
  } else {
    t6 = $[34];
  }
  let t7;
  if ($[35] !== t3 || $[36] !== t4 || $[37] !== t5 || $[38] !== t6) {
    t7 = <nav aria-label={t3} className={t4}>{t5}{t6}</nav>;
    $[35] = t3;
    $[36] = t4;
    $[37] = t5;
    $[38] = t6;
    $[39] = t7;
  } else {
    t7 = $[39];
  }
  return t7;
};
function _temp(prev_1) {
  return !prev_1;
}